import jwt_decode from "jwt-decode";
import moment from "moment";

export const getLocalParameters = async () => {
  const paramters: string | null = localStorage.getItem(`${process.env.REACT_APP_BASENAME}_localParameters`);
  
  if(paramters){
    return new Promise<LocalParameters>((resolve) => {
      resolve(JSON.parse(paramters))
    })
  }

  return new Promise<LocalParameters>((resolve) => {
    setTimeout(() => {
      resolve(window.localParameters);
    }, 1000);
  });
}

export function isTokenExpired(token: string | null): boolean {
  let isExpired = true;
  if(token){
    const decodedToken : IToken = jwt_decode(token);
    const dateNow = new Date();

    if(SecondsToMilliseconds(decodedToken.exp) > dateNow.getTime()){
      isExpired = false;
    }
  }
  return isExpired;
}

export function HelperGetDataTypes(response: any, fullResponse: boolean = false) {
  if (fullResponse) {
      console.log("data", response.data);
  }
  else {
      response.data.map((val: any, dt: string) => {
          if (val.columnDataType == "String")
              dt = "string";
          else if (val.columnDataType == "Integer")
              dt = "number";
          else if (val.columnDataType == "Boolean")
              dt = "boolean"
          else if (val.columnDataType == "Double")
              dt = "number"
          console.log("%c" + val.columnName + ": %c" + dt + ";", "color:black;", "color:red;")
      })
  }
}
//HelperGetDataTypes

function SecondsToMilliseconds(seconds: number): number{
  return seconds * 1000;
}

export const DateFormater = (unformattedDate: Date | string, formatStyle: string): string => {
  let formattedDate = "";

  try {
    const dateTime = moment(unformattedDate);
    formattedDate = dateTime.format(formatStyle);
  } catch (error) {
    console.log("error on convert date", error);
  }

  return formattedDate;
};

export const DateTimeAdditionSeconds = (date: Date | string, seconds: number): string =>  {
  const dateTime = moment(date).add(seconds, 'seconds');
  return dateTime.format('YYYY-MM-DDTHH:mm:ss.SSS');
}

export const SecondsToTimeFormat = (seconds: number, fromFormat: string = "seconds", toFormat: string = "HH:mm:ss"): string => {
  const date = moment.duration(seconds, fromFormat as moment.unitOfTime.DurationConstructor);
  return moment.utc(date.asMilliseconds()).format(toFormat);

}

export const isObjectEmpty = (obj: any): boolean =>{
  return Object.keys(obj).length === 0;
}

export interface requestApiType {
  type: 'get' | 'post' | 'put' | 'patch' | 'delete';
}

interface IToken {
  AppId: string;
  FirstName: string;
  ID: string;
  Language: string;
  LastName: string;
  UserType: string;
  UserName: string;
  aud: string;
  exp: number;
  iat: number;
  iss: string;
  nbf: string;
}

export enum IoType {
  Unknown = 6,
  Incoming = 1,
  Outgoing = 2,
}

export enum CallType {
  Unknown = 0,
  NotApplicable = 1,
  Mobile = 2,
  National = 3,
  OnePhone = 4,
  FreePhone = 5,
  HighRateLine = 6,
  SpecialServices = 7,
  Local = 8,
  International = 9,
  Internal = 10,
}

export enum Languages {
  Unknown = 0,
  English = 1,
  Greek = 2,
  German = 3,
  French = 4,
}

export function filterNonEmptyValues<T extends Record<string, any>>(inputObj: T): Partial<T> {
  const result: Partial<T> = {};
  for (const key in inputObj) {
      if (inputObj[key]) {
          result[key] = inputObj[key];
      }
  }
  return result;
}